import  { APIClient } from "../api";
import { CloseSolicitationView } from "../../models/CloseSolicitationView";

export default class CloseSolicitationService extends APIClient {

    // constructor(props: any) {
    //     super(props);
    // }

    async closeSolicitation(closeSolicitation: CloseSolicitationView) {
        const url = this.endpoint + `/FastCloseSolicitation/Close`;

        return this.api({
            method: 'post',
            url,
            headers: { "Content-Type": "application/json" },
            params: null,
            data: closeSolicitation
        });
    }
}